import axios from "axios";

const teamMemberInstance = axios.create({
  baseURL: `http://3.113.123.43:5000`,
});

export const getTeamMemberInstanceListEffect = (payload) => {
  const token = localStorage.getItem("user_id");
  return teamMemberInstance.request({
    url: `/teamMember/allList?pagination_required=true`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const addTeamMemberInstanceListEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return teamMemberInstance.request({
    url: `/teamMember/add`,
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const updateTeamMemberInstanceListEffect = (formData) => {
  const token = localStorage.getItem("user_id");
  return teamMemberInstance.request({
    url: `/teamMember/update`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const deleteTeamMemberInstanceListEffect = (payload) => {
  const token = localStorage.getItem("user_id");
  return teamMemberInstance.request({
    url: `/teamMember/delete/${payload?.id}`,
    method: "DELETE",

    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
